export const CHECK_API_SUCCESS = 'home/CHECK_API_SUCCESS'
export const CHECK_API_ERROR = 'home/CHECK_API_ERROR'

export const CHANGE_SERVICE_ORDER = 'management/CHANGE_SERVICE_ORDER'
export const CHANGE_SERVICE_ORDER_SUCCESS = 'management/CHANGE_SERVICE_ORDER_SUCCESS'
export const CHANGE_SERVICE_ORDER_ERROR = 'management/CHANGE_SERVICE_ORDER_ERROR'

export const GET_SERVICE_TYPES_ERROR = 'management/GET_SERVICE_TYPES_ERROR'
export const GET_SERVICE_TYPES_SUCCESS = 'management/GET_SERVICE_TYPES_SUCCESS'
export const GET_SERVICE_TYPES = 'management/GET_SERVICE_TYPES'

export const GET_STATES_SETTINGS = 'management/GET_STATES_SETTINGS'
export const GET_STATES_SETTINGS_SUCCESS = 'management/GET_STATES_SETTINGS_SUCCESS'
export const GET_STATES_SETTINGS_ERROR = 'management/GET_STATES_SETTINGS_ERROR'

export const SET_LOADING = 'management/SET_LOADING'

export const RESET_MANAGEMENT_ERROR = 'management/RESET_MANAGEMENT_ERROR'

export const CHANGE_TABS = 'management/CHANGE_TABS'
